var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1912",
    "data-name": "Group 1912",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.144,
    height: 37.435,
    viewBox: "0 0 27.144 37.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M89.51,323.535a3.356,3.356,0,0,1,2.861,3.486c.046,1.3.014,2.6.014,3.9q0,9.861,0,19.723c0,3.031-1.328,4.341-4.386,4.342q-9.228,0-18.457,0c-2.911,0-4.282-1.349-4.284-4.23q-.009-11.654,0-23.309c0-2.266.993-3.6,2.856-3.92a33.053,33.053,0,0,1,4.036-.077c.683-.014.7.415.525.92a1.672,1.672,0,0,1-1.285.34c-.774.026-1.55-.034-2.321.036A2.144,2.144,0,0,0,66.8,327.2c-.022,2.991-.007,5.982-.007,8.973q0,7.284,0,14.568c0,2.082.668,2.84,2.753,2.858q9.289.084,18.578,0c2.042-.021,2.715-.778,2.716-2.784q.01-11.665,0-23.329c0-1.912-.544-2.5-2.449-2.721-.7-.082-1.406-.03-2.109-.054a1.877,1.877,0,0,1-1.3-.307c-.186-.49-.222-.955.475-.949A29.457,29.457,0,0,1,89.51,323.535Z",
    transform: "translate(-65.252 -317.556)",
    fill: "none",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M100.2,301.68c-1.209,0-2.419.043-3.626,0-.729-.025-.925.286-.8.932-.028,1.069-.57,1.609-1.795,1.688-1.189.077-2.383.026-3.574.026-1.682,0-3.365.044-5.046-.02-1.282-.049-1.97-.638-2.106-1.694.123-.651-.079-.958-.808-.933-1.211.041-2.424,0-3.637-.006a13.724,13.724,0,0,1,3.548-.154c.518-.023.971-.015,1.159-.63a.964.964,0,0,1,.672-.632c.923-.207,1.147-.809,1.348-1.668.485-2.066,1.979-2.965,4.4-2.865A3.654,3.654,0,0,1,93.588,299c.1.633.273.935.909,1.029a1.115,1.115,0,0,1,.914.652c.284.9.948.823,1.665.841A10.017,10.017,0,0,1,100.2,301.68Z",
    transform: "translate(-75.944 -295.719)",
    fill: "none",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M125.342,307.543a1.514,1.514,0,0,1-3.024-.144,1.524,1.524,0,0,1,1.638-1.412A1.507,1.507,0,0,1,125.342,307.543Z",
    transform: "translate(-110.266 -303.816)",
    fill: "none",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M100.474,365.128a3.875,3.875,0,0,1,2.5,1.388c.614.845.427,1.54-.562,1.88a8.563,8.563,0,0,1-5.677.009c-1.014-.347-1.171-.967-.562-1.869a3.69,3.69,0,0,1,2.485-1.4c-1.917-1.276-2.55-2.511-2.093-4.043a3.083,3.083,0,0,1,3.068-2.247A3.119,3.119,0,0,1,102.6,361.1C103.02,362.728,102.4,363.916,100.474,365.128Z",
    transform: "translate(-89.359 -345.513)",
    fill: "none",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M102.7,423.862c2.074,0,4.149,0,6.223,0,.407,0,.972-.095.944.523-.024.527-.526.558-.975.558q-6.223-.008-12.446,0c-.451,0-.944-.047-.941-.586,0-.615.573-.491.972-.492C98.548,423.858,100.622,423.862,102.7,423.862Z",
    transform: "translate(-89.113 -396.797)",
    fill: "none",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M140.684,396.408c.736,0,1.472-.02,2.207.011.231.01.511.121.513.431s-.292.416-.517.418c-1.506.016-3.012.006-4.517-.015a.421.421,0,0,1-.453-.362c-.036-.329.221-.45.459-.458.769-.028,1.54-.011,2.31-.011Z",
    transform: "translate(-122.568 -375.14)",
    fill: "none",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M140.682,369.634c-.668,0-1.336.013-2-.006-.322-.009-.686-.079-.669-.5.016-.4.389-.345.653-.346,1.371-.011,2.742-.008,4.113,0,.278,0,.644-.013.679.34.043.427-.361.483-.664.5-.7.03-1.406.01-2.109.01Z",
    transform: "translate(-122.644 -353.348)",
    fill: "none",
    stroke: "#777777",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/Notepad.4a5c8693fd6b0cc5d2d7192973da5bb8.svg";
export { ForwardRef as ReactComponent };